import { useState } from "react";
import { InvoicingCodesDisclosure } from "@/forms/InvoicingCodesDisclosure/InvoicingCodesDisclosure";
import { InvoicingPicker } from "./InvoicingPicker";
import { useInvoicingCodesFromPatientId } from "@/api/Invoicing";
import { withPrefix } from "@/forms/fieldPath";

export const AddInvoicingCodesAction = ({
  patientId,
  namePrefix,
}: {
  patientId: string;
  namePrefix?: string;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { data: invoicingCodes } = useInvoicingCodesFromPatientId({
    patientId,
    codeType: null,
  });

  if (!invoicingCodes || invoicingCodes.length === 0) {
    return null;
  }

  return (
    <InvoicingCodesDisclosure
      procedureCodesFieldName={withPrefix(namePrefix, "procedureCodes")}
      productCodesFieldName={withPrefix(namePrefix, "productCodes")}
      invoicingCodes={invoicingCodes}
      isExpanded={isExpanded}
      onExpandedChange={setIsExpanded}
    >
      <InvoicingPicker patientId={patientId} namePrefix={namePrefix} />
    </InvoicingCodesDisclosure>
  );
};
